import React, { useEffect } from 'react'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';

const MypageLayout = () => {

    const navigate = useNavigate();
    const location = useLocation()
    const pathname = location.pathname

    const menuItems = [
        { path: '/mypage', label: '개인정보 변경' },
        { path: '/mypage/chat', label: '선생님과 소통' },
        { path: '/mypage/file', label: '파일 관리' },
    ];

    return (
        <div>
            <div className='title mb-5'>
                <h2 className='h2'>마이페이지</h2>
            </div>

            <div className='wrap-submenu pb-5'>
                <ul className='submenu'>
                    {menuItems.map((item) => (
                        <li key={'submenu-item-' + item.path} className={`submenu__item`} >
                            <NavLink to={item.path} className="submenu__link" end >{item.label}</NavLink>
                        </li>
                    ))}
                </ul>
            </div>

            <div className='content'>
                <Outlet />
            </div>
        </div>
    )
}

export default MypageLayout